//We should make this modal as this can be opened from any page

import React, { Component } from 'react';

import classNames from 'classnames';
import axios from 'axios';
import './styles.css';
import PropTypes from "prop-types";
import MobileModal from "../core/MobileModal/MobileModal";
import ConstantsLg from "../../ConstantsLg";
import Gutter from "../core/Gutter/Gutter";
import { GoogleLogin } from 'react-google-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import ContentLg from '../../ContentLg';
import LoginHeader2 from '../../components/core/LoginHeader/LoginHeader2';

let _cancelFbLogin = null ;
let _cancelGoogleLogin = null ;

class MobileLogin extends Component{

    constructor(props) {
        super(props);
        //
        this.state = {
            isModalOpen: true,
            loginInProgress: false
        };
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.callMeFacebook = this.callMeFacebook.bind(this);
        this.callMeGoogle = this.callMeGoogle.bind(this);
        this._getBase64Image = this._getBase64Image.bind(this);

        this.faceBookLoginClicked = this.faceBookLoginClicked.bind(this);

        this._onLoginSuccess = this._onLoginSuccess.bind(this);
        // this.CancelToken = axios.CancelToken;



        this._loginSuccess = false

    }

    onBackButtonEvent= (e) => {
        e.preventDefault();
        // console.log("back clicked");

        if(this._loginSuccess)
        {
            this.props.loginCallback();
        }
        else{
            this.setState({
                isModalOpen: false
            });
            this.props.positionChng();
        }
        window.onpopstate = null
    };

    componentWillMount = () =>{

    };

    componentDidMount (){
        
    };

    componentDidUpdate(){

    }

    openModal (){

    }

    _onLoginSuccess(){
        this.closeModal();
        window.Utils.setItemInStorage("ck_app_prev_job_list", null);
        window.Utils.setItemInStorage("ck_app_job_filters", null);
        window.Utils.setItemInStorage("ck_app_prev_job_list_scroll_top",0);
        this._loginSuccess = true;
    }

    closeModal(){
        if(_cancelGoogleLogin){
            _cancelGoogleLogin();
        }
        if(_cancelFbLogin){
            _cancelFbLogin();
        }
        this.props.positionChng();
        this.props.onCloseMobileModal();
    }

    callMeGoogleDummy(user_info){

        let CancelToken = axios.CancelToken;
        const fdata = new FormData();
        fdata.append('login_type','3');
        fdata.append('app_id','1');
        fdata.append('google_name', '');
        fdata.append('google_email','staging@talentxo.com');
        fdata.append('google_user_access_token','snxlaslxnsxtestjknsaxk123');
        fdata.append('google_user_id','');
        fdata.append('gl_profile_pic','');

        axios({
            timeout: 120 * 1000,
            method: 'post',
            url: '/loginmobile',
            withCredentials:true,
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                _cancelGoogleLogin  = c;
            }),
            data: fdata

        }).then( res => {

        }).catch( error =>{
            console.log(error);

        });
    }

    callMeGoogle(user_info){
        //make buttons inactive
        //show loading sign

        let CancelToken = axios.CancelToken;

        this.setState({
            loginInProgress: true
        });
        let onSuccess = this._onLoginSuccess;
        //FIXME write in try catch
        this._getBase64Image(user_info['google_user_profile_pic'], function(profile_data_url){

            const fdata = new FormData();
            fdata.append('login_type','3');
            fdata.append('app_id','1');
            fdata.append('google_name', user_info['google_name']);
            fdata.append('google_email',user_info['google_email']);
            fdata.append('google_user_access_token',user_info['google_user_access_token']);
            fdata.append('google_user_id',user_info['google_user_id']);
            fdata.append('gl_profile_pic',profile_data_url);

            axios({
                timeout: 120 * 1000,
                method: 'post',
                url: '/loginmobile',
                withCredentials:true,
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    _cancelGoogleLogin  = c;
                }),
                data: fdata

            }).then( res => {
                if(res.data.authentication_result.is_first_time_user === true){
                    window.triggerCkAnalytics("send", "event", "Mobile - Login/Signup ", "Professional - Login Success", "Google Login", "New User")
                }else{
                    window.triggerCkAnalytics("send", "event", "Mobile - Login/Signup ", "Professional - Login Success", "Google Login", "Returning User");
                }

                onSuccess();
                //    if success close the modal and set state in calling calling component
                //    or make auth chack
            }).catch( error =>{
                console.log(error);
                //FIXME should use intercepter
                this.setState({
                    loginInProgress : false
                });
            });
        }.bind(this));
    }

    callMeFacebook(user_info){
        //make buttons inactive
        //show loading sign

        //FIXME should use intercepter
        this.setState({
            loginInProgress : true
        });
        //FIXME use try catch
        let onSussess = this._onLoginSuccess ;
        this._getBase64Image(user_info['fb_profile_pic_url'], function(profile_data_url){

            let fb_ids_for_business = '';
            const obj = user_info['fb_ids_for_business_list'];
            let listSize = Object.keys(obj).length;
            Object.keys(obj).map((key,index) =>{
                if(index === listSize-1)
                    fb_ids_for_business += obj[key].id;
                else
                    fb_ids_for_business += obj[key].id + ',' ;
            });

            const dataToSend = new FormData();
            dataToSend.append('login_type', '2');
            dataToSend.append('app_id','1');
            dataToSend.append('fb_name', user_info['fb_name']);
            dataToSend.append('fb_email_address', user_info['fb_email_address']);
            dataToSend.append('fb_user_id', user_info['fb_user_id']);
            dataToSend.append('fb_user_access_token', user_info['fb_user_access_token']);
            dataToSend.append('fb_ids_for_business', fb_ids_for_business);
            dataToSend.append('fb_profile_pic', profile_data_url);

            let CancelToken = axios.CancelToken;

            axios({
                timeout: 120 * 1000,
                method: 'post',
                url: '/loginmobile',
                withCredentials:true,
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    _cancelFbLogin = c;
                }),
                data: dataToSend
            }).then( res => {
                
                if(res.data.data.is_new_user == 1){
                    window.triggerCkAnalytics("send", "event", "Mobile - Login/Signup ", "Professional - Login Success", "Facebook Login", "New User")
                }else{
                    window.triggerCkAnalytics("send", "event", "Mobile - Login/Signup ", "Professional - Login Success", "Facebook Login", "Returning User");
                }

                onSussess();
            }).catch( error =>{
                console.log(error);
                this.setState({
                    loginInProgress : false
                });
            });

        }.bind(this));
    }

    _getBase64Image = (img_url, callBack) => {
        let img = new Image();
        img.setAttribute('crossOrigin', 'anonymous'); // required for security exception. else canvas gets tainted
        img.src = img_url;

        // Create an empty canvas element
        let canvas = document.createElement("canvas");

        let checkExist = setInterval(function() {
            if(img.naturalHeight > 0 && img.naturalWidth > 0){
                clearInterval(checkExist);

                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;

                // Copy the image contents to the canvas
                let ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);

                // Get the data-URL formatted image
                // Firefox supports PNG and JPEG. You could check img.src to
                // guess the original format, but be aware the using "image/jpg"
                // will re-encode the image.
                // const dataURL = canvas.toDataURL("image/png");

                /*return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");*/
                // $_input_ele.val(dataURL);

                callBack(canvas.toDataURL("image/png"));
            }
        }, 100);
    };

    googleLoginClicked = () => {
        window.triggerCkAnalytics("send", "event", "Mobile - Login/Signup ", "Professional - Login Clicked", "Google Clicked");
    };

    faceBookLoginClicked(e) {
        // e.preventDefault();
        window.triggerCkAnalytics("send", "event", "Mobile - Login/Signup ", "Professional - Login Clicked", "Facebook Clicked");
        window.signupwithFacebook(this.callMeFacebook);
    };

    responseGoogleSuccess = (response) => {
        this.props.showAppLodingView();
        this.responseGoogleSuccessAfterLoading(response);
    };

    responseGoogleSuccessAfterLoading = (response) => {
        
        let user_info = {};
        user_info['google_name'] = response.profileObj.name;
        user_info['google_email'] = response.profileObj.email;
        user_info['google_user_access_token'] = response.accessToken;
        user_info['google_user_id'] = response.profileObj.googleId;
        user_info['google_user_profile_pic'] = response.profileObj.imageUrl;
        let CancelToken = axios.CancelToken;
        this._getBase64Image(user_info['google_user_profile_pic'], function(profile_data_url){

            const fdata = new FormData();
            fdata.append('login_type','3');
            fdata.append('app_id','1');
            fdata.append('google_name', user_info['google_name']);
            fdata.append('google_email',user_info['google_email']);
            fdata.append('google_user_access_token',user_info['google_user_access_token']);
            fdata.append('google_user_id',user_info['google_user_id']);
            fdata.append('gl_profile_pic',profile_data_url);
            fdata.append('action_type', ConstantsLg.ACTIONS.ACTION_LOGIN_USING_GOOGLE);
            fdata.append('google_login_id_token', response.tokenId ? response.tokenId : (response.tokenObj && response.tokenObj.id_token) ? response.tokenObj.id_token : null);
            
            axios({
                timeout: 120 * 1000,
                method: 'post',
                url: ConstantsLg.ROUTE.PROF_LOGIN_BY_EMAIL,
                withCredentials:true,
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    _cancelGoogleLogin  = c;
                }),
                data: fdata

            }).then( res => {
                if(res.data.data.login_info.is_new_user == 1){
                    window.triggerCkAnalytics("send", "event", "Login/Signup", "Professional - Login Success", "Google Login", "New User");
                }else{
                    window.triggerCkAnalytics("send", "event", "Login/Signup", "Professional - Login Success", "Google Login", "Returning User");
                }
                this.onSuccessGoogleLogin();
                
            }).catch( error =>{
                console.log(error);
                //FIXME should use intercepter
                this.setState({
                    loginInProgress : false
                });
            });
        }.bind(this));
    };

    responseGoogleFailure = (response) => {
        console.log(response);
        console.log("Failure")
    };

    responseFacebook = (response) => {
        this.props.showAppLodingView();
        this.responseFacebookSuccessAfterLoading(response);
    };

    responseFacebookSuccessAfterLoading = (response) => {
        let user_info = {};
        user_info['fb_user_id'] = response.userID;
        user_info['fb_user_access_token'] = response.accessToken;
        user_info['fb_name'] = response.name;
        user_info['fb_email_address'] = response.email;
        user_info['fb_ids_for_business_list'] = response.ids_for_business.data;
        user_info['fb_profile_pic_url'] = response.picture.data.url;
        this._getBase64Image(user_info['fb_profile_pic_url'], function(profile_data_url){

            let fb_ids_for_business = '';
            const obj = user_info['fb_ids_for_business_list'];
            let listSize = Object.keys(obj).length;
            Object.keys(obj).map((key,index) =>{
                if(index === listSize-1)
                    fb_ids_for_business += obj[key].id;
                else
                    fb_ids_for_business += obj[key].id + ',' ;
            });

            const dataToSend = new FormData();
            dataToSend.append('login_type', '2');
            dataToSend.append('app_id','1');
            dataToSend.append('fb_name', user_info['fb_name']);
            dataToSend.append('fb_email_address', user_info['fb_email_address']);
            dataToSend.append('fb_user_id', user_info['fb_user_id']);
            dataToSend.append('fb_user_access_token', user_info['fb_user_access_token']);
            dataToSend.append('fb_ids_for_business', fb_ids_for_business);
            dataToSend.append('fb_profile_pic', profile_data_url);

            let CancelToken = axios.CancelToken;

            axios({
                timeout: 120 * 1000,
                method: 'post',
                url: '/loginmobile',
                withCredentials:true,
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    _cancelFbLogin = c;
                }),
                data: dataToSend
            }).then( res => {
                if(res.data.data.login_info.is_new_user == 1){
                    window.triggerCkAnalytics("send", "event", "Login/Signup", "Professional - Login Success", "Facebook Login", "New User");
                }else{
                    window.triggerCkAnalytics("send", "event", "Login/Signup", "Professional - Login Success", "Facebook Login", "Returning User");
                }

                this.onSuccessFacebookLogin(res);
            }).catch( error =>{
                console.log(error);
                this.setState({
                    loginInProgress : false
                });
            });

        }.bind(this));
    };

    onSuccessGoogleLogin = () => {
        this.onSuccessLoginGoogle();
    };

    onSuccessLoginGoogle = () => {
        this.props.onLoginSuccessProfessionalMobile();
    };

    onSuccessFacebookLogin = () => {
        this.onSuccessLoginFacebook();
    };

    onSuccessLoginFacebook = () => {
        this.props.onLoginSuccessProfessionalMobile();
    };

    // onSuccessLogin = () => {
    //     if(this.props.toRedirectPageIdentifier) {
    //         window.location.href = '/jobs';
    //     }
    //     else {
    //         window.location.reload();
    //     }
    // };

    onClickLoginWithEmail = () => {
        this.props.onClickChangeUserLoginModal(ConstantsLg.LOGIN_TYPE.PROFESSIONAL_EMAIL_MOBILE);
    };

    render(){

        const {loginInProgress} = this.state;
        const loginClasses = classNames('mobile-lg-btns-wrpr');

        const inProgressClasses = classNames('lg-loading-message', {'display_gone': (loginInProgress === false)});
        return(
            <div className="mobile-login-modal-wrapper">
                <MobileModal 
                    isOpen = {this.state.isModalOpen} 
                    onClose = {() => this.closeModal()} 
                    style = {{
                        top:'30%',
                        height:'70%'
                    }} 
                    {...this.props}
                    noBackdrop = {false}
                >
                {/* <LoginHeader2 
                    title = {ContentLg.SIGNUP_LOGIN}
                    iconUrl = {ConstantsLg.ICONS.CROSS_ICON}
                    onClickCrossIcon = {this.closeModal}

                    customStyleLoginPopupHeader = {{
                        padding: '0',
                        width: '100%',
                        justifyContent: 'space-between'
                    }}

                    leftChildStyle = {{
                        marginLeft: '10px'
                    }}

                    rightChildStyle = {{
                        marginRight: '10px'
                    }}
                /> */}

                    <div className="lp_parent_header_container">
                        <div className="lp_header_container">
                            <span className="lp_content_title padding4">{ContentLg.CANDIDATE_LANDING_SUB_HDR}</span>
                        </div>
                    </div>

                    <div className="login-container-main">
                        <div className={loginClasses}>
                            <GoogleLogin
                                clientId = {ConstantsLg.GOOGLE_CLENT_ID}
                                render={renderProps => (
                                    <div className="gl-login">
                                        <button
                                            className="btn"
                                            id='google-login-btn'
                                            ref = { (googleBtn) => {this.googleBtn = googleBtn;} }
                                            onClick = {renderProps.onClick}
                                        >
                                            <div className="inner-parent">
                                                <div className="logo-container"></div>
                                                <div className='text-container'>
                                                    Continue with Google
                                                </div>
                                            </div>
                                        </button>

                                    </div>
                                )}
                                onSuccess = {this.responseGoogleSuccess}
                                onFailure = {this.responseGoogleFailure}
                            />

                            {/* <FacebookLogin
                                appId = {ConstantsLg.FACEBOOK_APP_ID}
                                // autoLoad = {true}
                                disableMobileRedirect = {true}
                                fields = "name,email,picture,ids_for_business"
                                render = {renderProps => (
                                    <div className="fb-login">
                                        <button
                                            className = "btn"
                                            onClick = {renderProps.onClick}
                                        >
                                            <div className="inner-parent">
                                                <div className="logo-container"></div>
                                                <div className="text-container">
                                                    Continue with Facebook
                                                </div>
                                            </div>

                                        </button>
                                    </div>

                                )}
                                callback={this.responseFacebook}
                            /> */}

                                    <div className="email-login">
                                        <button
                                            className = "btn"
                                            onClick = {this.onClickLoginWithEmail}
                                        >
                                            <div className="inner-parent">
                                                {/* <div className="logo-container"></div> */}
                                                <i class="material-icons email-login-mobile">email</i>
                                                <div className="text-container">
                                                    Continue with Email Id
                                                </div>
                                            </div>

                                        </button>
                                    </div>
                            
                        </div>

                        <div className='line-div'>
                            <div className='line'></div>
                        </div>

                        <div className='detail'>
                            <div className='detail-div'>Are you a Recruiter or Hiring Manager? <span className='block'>Please use our website on the desktop</span></div>
                        </div>
                    </div>
                </MobileModal>
            </div>
        );
    }
}
MobileLogin.propTypes = {
    hist: PropTypes.object,

};

/**
 * Only if default initialization is required
 * Default props value for this component
 */
MobileLogin.defaultProps = {

};

export default MobileLogin;



// WEBPACK FOOTER //
// ./src/components/MobileLogin/MobileLogin.js


// WEBPACK FOOTER //
// ./src/components/MobileLogin/MobileLogin.js